import { useMutation } from "@tanstack/react-query";

import { ADMIN_USER_KEY } from "../../constants/query-keys";
import { axios } from "../../libs/axios";
import { queryClient } from "../../libs/query-client";
import { useAuthStore } from "../../stores/auth";

// Clears the `admin_*` cookie pair only — the consumer-app `Authentication`
// cookie on `app.resumestudio.io` is on a different host scope and is
// completely untouched.
export const adminLogout = () => axios.post("/admin/auth/logout");

export const useAdminLogout = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: logoutFn,
  } = useMutation({
    mutationFn: adminLogout,
    onSuccess: () => {
      setUser(null);
      queryClient.setQueryData(ADMIN_USER_KEY, null);
      queryClient.clear();
    },
    onError: () => {
      // Even if the server call fails (e.g. token already expired), wipe
      // local state so the next page render shows the login page rather
      // than a half-authenticated chrome.
      setUser(null);
      queryClient.setQueryData(ADMIN_USER_KEY, null);
      queryClient.clear();
    },
  });

  return { logout: logoutFn, loading, error };
};
